
import { Box, Typography } from "@mui/material"
import { useIsMobileView } from "../../utils/responsive";
import { RafflesList } from "../raffles/raffle-list";


export const RafflesPage = () => {
    const isMobileView = useIsMobileView();
    return (
        <Box paddingX={isMobileView ? 2 : 10} marginTop={2} paddingBottom={8}>
        <RafflesList></RafflesList>
    </Box>
)
}